module.exports = __webpack_public_path__ + "static/media/header-logo.13e9e2dd.png";